<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1dRfMD/tc-custom/9781596439597.jpg?1737767945672" alt="This image is the cover for the book The Emperor's Ostrich"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Emperor's Ostrich
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Magic and mayhem abound in this fantasy adventure from the author of <i>The Scandalous Sisterhood of Prickwillow Place</i>.</b><br/><br/>Young dairymaid Begonia has lost her cow Alfalfa. So she has set off on a search across the countryside even though she has nothing but a magical map to guide her. Along the way she meets a mother and baby, a woodcutter, a very dirty young man, and an eight-foot ostrich. <br/><br/>Meanwhile, the emperor has gone missing from the royal palace in a most mysterious manner. Was it murder? Was it magic? It will take all of Begonia's wits to save the empire and get Alfalfa home safely.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Berry
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Roaring Brook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72cbc777